import React, {useEffect} from 'react';
import {injectIntl} from 'react-intl';
import CheckboxField from '@FormComponents/CheckboxField';

const SkillsFilter = ({intl, skills, dataSkills, setDataSkills}) => {
  useEffect(() => {
    if (dataSkills && (typeof dataSkills === 'string' || dataSkills instanceof String)) {
      let data = {};
      dataSkills.split(',').forEach((item) => {
        data = {
          ...data,
          [item]: true,
        };
      });
      setDataSkills((prev) => {
        return {
          ...prev,
          skills: data,
        };
      });
    }
  }, []);

  const onChange = (event) => {
    event.propertyIsEnumerable();
    const name = event.target.name;
    const value = event.target.checked;
    setDataSkills((prev) => {
      return {
        ...prev,
        skills: {
          ...prev.skills,
          [name]: value,
        },
      };
    });
  };

  const renderSkills = () => {
    let result = [];
    if (skills && skills.length) {
      result = skills.map((skill, index) => {
        return (
          <div key={index} className="form-group__input">
            <label className="selection-control selection-control--checkbox">
              <span className="selection-control__input">
                <CheckboxField checked={!!(dataSkills && dataSkills[skill.label] === true)} name={skill.label} onChange={onChange}/>
                <span className="icon selection-control__control" aria-hidden={true}>
                  <svg viewBox="0 0 16 16">
                    <polyline points="2.1,8.5 6.2,12.4 13.9,5.1" />
                  </svg>
                </span>
              </span>
              <span className="selection-control__label">
                {`${skill.label} (${skill.count})`}
              </span>
            </label>
          </div>
        );
      });
    }
    return result;
  };

  return (
    <>
      {renderSkills()}
    </>
  );
};

export default injectIntl(SkillsFilter);
